/**
 * Registry of non-essential Rovo Chat localStorage keys.
 *
 * Add new non-essential keys here to allow them to be selectively disabled
 * via the Statsig dynamic config `rovo_chat_disabled_non_essential_ls_keys`
 * during an incident — without requiring a code deploy.
 *
 * A key is "non-essential" if Rovo Chat can function correctly without it
 * (e.g. a UI preference or optimisation). Wrap all accesses to these keys
 * with `withNonEssentialLocalStorage`.
 */
export const LS_CHAT_LOAD_PREFERENCE_KEY = 'aiMateChatLoadPreference';
export const LS_RECENT_CONVERSATION_ACTIVITY_KEY = 'rovoChatRecentConversationActivity';
export const LS_USER_PREFERENCES_KEY = 'aiMateUserPreferences';
export const LS_SIDE_NAV_COLLAPSED_KEY = 'is-rovo-sidenav-collapsed';
export const LS_SIDE_NAV_WIDTH_KEY = 'rovo-sidenav-width';
export const LS_ROVO_SETTINGS_AVAILABLE_CONNECTORS_CACHE_KEY =
	'rovoSettingsAvailableConnectorsCache';
export const LS_CWR_CHAT_PANEL_WIDTH_KEY = 'rovoCwrChatPanelWidth';

export const NON_ESSENTIAL_LOCAL_STORAGE_KEYS: readonly [
	typeof LS_CHAT_LOAD_PREFERENCE_KEY,
	typeof LS_RECENT_CONVERSATION_ACTIVITY_KEY,
	typeof LS_USER_PREFERENCES_KEY,
	typeof LS_SIDE_NAV_COLLAPSED_KEY,
	typeof LS_SIDE_NAV_WIDTH_KEY,
	typeof LS_ROVO_SETTINGS_AVAILABLE_CONNECTORS_CACHE_KEY,
	typeof LS_CWR_CHAT_PANEL_WIDTH_KEY,
] = [
	LS_CHAT_LOAD_PREFERENCE_KEY,
	LS_RECENT_CONVERSATION_ACTIVITY_KEY,
	LS_USER_PREFERENCES_KEY,
	LS_SIDE_NAV_COLLAPSED_KEY,
	LS_SIDE_NAV_WIDTH_KEY,
	LS_ROVO_SETTINGS_AVAILABLE_CONNECTORS_CACHE_KEY,
	LS_CWR_CHAT_PANEL_WIDTH_KEY,
];
